import React from 'react'
import SecModule from './SecModule';
import moduleData from './Data/Data';

const MainSecond = React.memo(() => {
  return (
    <>
      <div className="relative bg-[#ffffff] flex flex-col justify-center items-center sm:mt-0 px-3 sm:px-10 mb-10">
        <div className="w-full max-w-7xl mt-14">
          <div className="text-center text-5xl font-semibold pb-14 pt-10">
            We make your business{" "}
            <span
              className=""
              style={{
                backgroundImage:
                  "linear-gradient(120deg, #0077b3 0%, #00aacc 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Accounting & GST
            </span>{" "}
            Reporting easy
          </div>
          <SecModule dataStore={moduleData} />
          <div className="w-full flex justify-end mt-2 mb-4">
            <a
              href="https://www.easyofficesoftware.com/easyacc"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-end"
            >
              <p className="mb-0 mr-1 text-black text-lg font-bold">
                Learn More
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </>
  );
});

export default MainSecond;